import React, { useEffect, useRef, useState } from "react";
import BlockUnitGrid from "../BlockUnitGrid/BlockUnitGrid";
import { useGlobalState } from "../../GlobalState";
import { v4 as uuidv4 } from 'uuid';

/**
 * 
 * @param {*} params 
 * @returns 
 */
export function Block( { params }) {
 
    const TYPES = ['T', 'L', 'X', '.', 'l', '[]', '[', ']', '#', 'h3', 'l2', 'l3'];
    const BLOCK_UNIT_GRID_SIZE = 3;
    const SELECTED_UNIT_RATIO = 1;
    const { BASE_LENGTH_PX } = useGlobalState();

    const SELECTED_LENGTH = (BLOCK_UNIT_GRID_SIZE*(BASE_LENGTH_PX*SELECTED_UNIT_RATIO))/2;
    
    const getShape = (( type )=>{
        switch( type ){
            case 'T':
                return [[1,1,1],[0,1,0],[0,1,0]];
            case 'L':
                return [[0,1,0],[0,1,0],[0,1,1]];
            case 'X':
                return [[0,1,0],[1,1,1],[0,1,0]];
            case '.':
                return [[0,0,0],[0,1,0],[0,0,0]];
            case 'l':
                return [[0,0,0],[0,1,0],[0,1,0]];
            case '[]':
                return [[1,1,1],[1,1,1],[1,1,1]];
            case '[':
                return [[1,1,0],[1,1,0],[1,1,0]];
            case ']':
                return [[0,0,0],[1,1,1],[1,1,1]];
            case '#':
                return [[0,0,0],[0,1,1],[0,1,1]];
            case 'h3':
                return [[0,1,0],[0,1,0],[0,1,0]];
            case 'l2':
                return [[0,0,0],[0,1,1],[0,0,0]];
            case 'l3':
                return [[0,0,0],[1,1,1],[0,0,0]];
            default:
                return [[1,1,1],[0,1,0],[0,1,0]];
        }
    });

    const getColor = (( type )=>{
        switch( type ){
            case 'T':
                return 'blue';
            case 'L':
                return 'green';
            case 'X':
                return 'red';
            default:
                return 'blue';
            case '.':
                return 'yellow';
            case 'l':
                return 'purple';
            case '[]':
                return 'pink';
            case '[':
                return 'orange';
            case ']':
                return 'brown';
            case '#':
                return 'gray';
            case 'h3':
                return 'violet';
            case 'l2':
                return 'lightblue';
            case 'l3':
                return 'olive';
        }
    });

    const getPath = (( type )=>{
        switch( type ){
            case 'T':
                return ['right','right','right','left','down','down'];
            case 'L':
                return ['down','down','right'];
            case 'X':
                return ['down','left','right','right','left','down'];
            case '.':
                return [];
            case 'l':
                return ['down'];
            case '[]':
                return ['right','right','down','left','left','down','right','right'];
            case '[':
                return ['right','down','left','down','right'];
            case ']':
                return ['right','right','down','left','left'];
            case '#':
                return ['right','down','left'];
            case 'h3':
                return ['down','down'];
            case 'l2':
                return ['right'];
            case 'l3':
                return ['right', 'right'];
            default:
                return [];
        }
    });


    const [ type, setType ] = useState( params.type || TYPES[Math.floor(Math.random()*TYPES.length)] )
    const [ shape, setShape ] = useState( getShape( type ) );
    const [ path, setPath ] = useState( getPath( type ) );
    const [ color, setColor ] = useState( getColor( type ) );
    const [ isSelected, setIsSelected ] = useState( params?.isSelected ?? false );
    const [ isPlaced, setIsPlaced ] = useState( params?.isPlaced ?? false );

    const [ blockUnitLengthRatio, setBlockUnitLengthRatio ] = useState( isSelected ? 1 : SELECTED_UNIT_RATIO );

    const { mousePos, selectedBlock, setSelectedBlock } = useGlobalState();

    const blockRef = useRef(null);

    const handleSelectedClick = (event) => {
      if( selectedBlock && isSelected && !document.getElementById("gameboard-grid").contains(event.target)){
        setSelectedBlock(false)
        setIsSelected(false)
      }
    };

    /**
     * Click -> Mouse down - mouseup
     */
    const handleMousedown= () =>{
        console.log(selectedBlock)
        if(selectedBlock !== false)
            return;

        if(!isSelected){
            setIsSelected(true); 
            setSelectedBlock({shape:shape, trayIndex:params.index});
        } 
    }

    const handleTouchstart = (e) =>{
        if(selectedBlock !== false)
            return;
        if (document.getElementById(params.id).contains(e.target)){
            if(!isSelected){
                setIsSelected(true); 
                setSelectedBlock({shape:shape, trayIndex:params.index});
            } 
        }
    }

    const handleMouseup= () =>{
        console.log(selectedBlock)
        
        if(isSelected){
            setIsSelected(false); 
            setSelectedBlock(false)
        }
    }


    const handleClick = () =>{
        console.log(selectedBlock)
        if(!isSelected && selectedBlock !== false)
            return;

        if(!isSelected){
            setIsSelected(true); 
            setSelectedBlock({shape:shape, trayIndex:params.index});
        } 
    }


    useEffect(()=>{
        const block = blockRef.current;
        block.addEventListener('mousedown', handleMousedown);
        window.addEventListener('touchstart', handleTouchstart);


        window.addEventListener("mouseup", handleMouseup);
        window.addEventListener("touchend", handleMouseup);

        return () => {
            block.removeEventListener('mousedown', handleMousedown);
            window.removeEventListener('touchstart', handleTouchstart);

            window.removeEventListener("mouseup", handleMouseup);
            window.removeEventListener("touchend", handleMouseup);
        };
    },[selectedBlock]);


    useEffect(()=>{
        if(selectedBlock === false)
            setIsSelected(false)
    },[selectedBlock]);

    return (
        <div ref={blockRef} style={{
            position: !isSelected ? 'relative':'fixed',
            top: !isSelected ? 'auto' : mousePos.y-SELECTED_LENGTH,
            left: !isSelected ? 'auto' : mousePos.x-SELECTED_LENGTH,
            zIndex: !isSelected ? 1 : 9999,
            pointerEvents: !isSelected ? 'auto': 'none'
        }} id={params.id} data-path={JSON.stringify(path)}>
            <BlockUnitGrid params={{
                isOutline:false,
                rowCount: BLOCK_UNIT_GRID_SIZE,
                colCount: BLOCK_UNIT_GRID_SIZE,
                shape: shape,
                color: color,
                lengthRatio: !isSelected ? 1 : SELECTED_UNIT_RATIO
            }}></BlockUnitGrid>   
        </div>
    );
}